import { render, staticRenderFns } from "./RedTemplate.vue?vue&type=template&id=09ca5a56&scoped=true&"
import script from "./RedTemplate.vue?vue&type=script&lang=js&"
export * from "./RedTemplate.vue?vue&type=script&lang=js&"
import style0 from "./RedTemplate.vue?vue&type=style&index=0&id=09ca5a56&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "09ca5a56",
  null
  
)

export default component.exports